var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 68.75V6.25C100 2.7969 97.2031 0 93.75 0H6.25C2.7969 0 0 2.7969 0 6.25V68.75C0 72.2031 2.7969 75 6.25 75H93.75C97.2031 75 100 72.2031 100 68.75ZM4.168 16.668V6.25C4.168 5.09769 5.09762 4.16792 6.24992 4.16792H93.7499C94.3007 4.16792 94.832 4.3866 95.2226 4.7773C95.6133 5.168 95.832 5.69922 95.832 6.25V16.668H4.168ZM95.832 20.832V68.75C95.832 69.3008 95.6135 69.8321 95.2228 70.2227C94.8321 70.6133 94.3009 70.8321 93.7501 70.8321H6.25008C5.69926 70.8321 5.16801 70.6134 4.77738 70.2227C4.38675 69.832 4.168 69.3008 4.168 68.75V20.832H95.832ZM14.5821 12.5H10.418C9.26569 12.5 8.3321 11.5664 8.3321 10.418C8.3321 9.26569 9.2657 8.3321 10.418 8.3321H14.5821C15.7344 8.3321 16.668 9.2657 16.668 10.418C16.668 11.5664 15.7344 12.5 14.5821 12.5ZM27.0821 12.5H22.918C21.7657 12.5 20.8321 11.5664 20.8321 10.418C20.8321 9.26569 21.7657 8.3321 22.918 8.3321H27.0821C28.2344 8.3321 29.168 9.2657 29.168 10.418C29.168 11.5664 28.2344 12.5 27.0821 12.5ZM39.5821 12.5H35.418C34.2657 12.5 33.3321 11.5664 33.3321 10.418C33.3321 9.26569 34.2657 8.3321 35.418 8.3321H39.5821C40.7344 8.3321 41.668 9.2657 41.668 10.418C41.668 11.5664 40.7344 12.5 39.5821 12.5ZM64.5 40C66.9853 40 69 37.9853 69 35.5C69 33.0147 66.9853 31 64.5 31C62.0147 31 60 33.0147 60 35.5C60 37.9853 62.0147 40 64.5 40ZM55 55C55 58.866 52.9853 62 50.5 62C48.0147 62 46 58.866 46 55C46 51.134 48.0147 48 50.5 48C52.9853 48 55 51.134 55 55ZM35.5 40C37.9853 40 40 37.9853 40 35.5C40 33.0147 37.9853 31 35.5 31C33.0147 31 31 33.0147 31 35.5C31 37.9853 33.0147 40 35.5 40Z",
    fill: "url(#paint0_linear_1151_28047)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1151_28047",
    x1: 35.5973,
    y1: 45.6423,
    x2: 60.3525,
    y2: 20.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#EE4F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#F06022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#F37820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    stopColor: "#F7951D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA61A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.d2a90f2d76b96804085af3bc4c1f2c2f.svg";
export { ForwardRef as ReactComponent };